import { Request } from "./HttpService";

export const permissionService = {
  getUserPermissions(userId) {
    return Request(`userAccess/permission/user/${userId}`, "GET");
  },
  saveUserFunctionalities(userId, functionalities) {
    return Request(
      `userAccess/permission/user/${userId}`,
      "POST",
      functionalities
    );
  },
  getRolePermissions(roleId) {
    return Request(`userAccess/permission/role/${roleId}`, "GET");
  },
  saveRoleFunctionalities(roleId, functionalities) {
    return Request(
      `userAccess/permission/role/${roleId}`,
      "POST",
      functionalities
    );
  }
};
